import React from 'react';
import styled from 'styled-components';

import EmbedModalWithGreenHeader from 'src/presentation/components/pages/shared/EmbedModalWithGreenHeader';
import { isLoadingStatus } from 'src/presentation/hooks/useResource';
import { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';
import { Spinner } from 'src/presentation/components/pages/shared/Spinner';
import ViewChannelIntegrationDataForm from './ViewChannelIntegrationDataForm';

const ViewChannelIntegrationDataFormModal = ({ onClose, value, loadingState }) => {
  return (
    <StyledModal
      data-aid="view-channel-configuration"
      title="View integration data"
      content={
        <>
          {isLoadingStatus(loadingState) ? (
            <SpinnerWrapper>
              <Spinner />
            </SpinnerWrapper>
          ) : (
            <ViewChannelIntegrationDataForm onClose={onClose} item={value} />
          )}
        </>
      }
      onCancel={onClose}
      modalSize={ModalSize.LARGE}
    />
  );
};

const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const StyledModal = styled(EmbedModalWithGreenHeader)`
  padding: 0;
`;

export default ViewChannelIntegrationDataFormModal;
